import {
    CREATE_OBJECT_SUCCESS,
    DELETE_OBJECT_FAILURE,
    DELETE_OBJECT_REQUEST,
    DELETE_OBJECT_SUCCESS,
    DT_FAILURE,
    DT_REQUEST,
    DT_SUCCESS,
    SAVE_OBJECT_SUCCESS,
    ACTION_OBJECT_REQUEST,
    ACTION_OBJECT_SUCCESS,
    ACTION_OBJECT_FAILURE
} from '../actions/api'
import { SortDirection } from 'react-virtualized/dist/commonjs/Table'
import _ from 'lodash'
import {
    SET_COLUMN_SELECTOR_OPENED,
    SET_ACTION_SELECTOR_OPENED,
    SET_FILTERS_OPENED,
    CLEAR_ERRORS,
    FILTER_DATA_TABLE,
    INITIALIZE_MODULE,
    SORT_DATA_TABLE,
    SET_DATA_TABLE_SORT,
    SET_DATA_TABLE_FILTER_MODEL,
    TOGGLE_COLUMN_VISIBILITY,
    SET_LIST_ELEMENT_SELECTION,
    SET_FIELD_WIDTH
} from '../actions'

const getDataIds = data => data.map(o => o.id)

function isEmpty(str) {
    return (!str || 0 === str.length);
}

function valueMatchesTarget(value, target) {
    if (isEmpty(target)) return true
    const matchAsString =
        _.isString(value) &&
        value.toLowerCase().search(target.toLowerCase()) !== -1
    const matchAsNumber = _.isNumber(value) && value === _.parseInt(target)
    return matchAsString || matchAsNumber
}

const sortGetterForFields = ({ listFieldsById }) => ({ fields, sortBy }) => {
    const sortedFieldId = fields.find(
        fieldId => listFieldsById[fieldId].path === sortBy
    )
    return listFieldsById[sortedFieldId].dataGetter
}

const filterGetterForFields = ({ listFieldsById }) => ({
    fields,
    visibleColumns
}) => {
    return fields.reduce((acc, fieldId) => {
        const field = listFieldsById[fieldId]
        if (
            !field.disableFilter &&
            field.dataGetter &&
            visibleColumns[field.id]
        ) {
            if (field.type === 'status') {
                acc.push(object => {
                    const statusObj = field.dataGetter(object)
                    return statusObj && statusObj.value
                })
            } else {
                acc.push(field.dataGetter)
            }
        }
        return acc
    }, [])
}

const sort = (ids, getValueForId, sortDirection) =>
    _.orderBy(
        ids,
        getValueForId,
        sortDirection === SortDirection.ASC ? 'asc' : 'desc'
    )

const defaultState = {
    allIds: [],
    byId: {},
    columnSelectorOpened: false,
    actionSelectorOpened: false,
    deleteAccessId: null,
    error: null,
    errorStatus: null,
    initialFields: [],
    fields: [],
    filter: '',
    filterModel: {},
    sortedIds: [],
    filteredSortedIds: [],
    filtersOpened: true,
    isFetching: false,
    sortBy: null,
    sortDirection: null,
    visibleColumns: {}
}

const list = (state = defaultState, action) => {

    const getSortDataGetter = action.meta && sortGetterForFields(action.meta)
    const getFilterDataGetter =
        action.meta && filterGetterForFields(action.meta)
    const localStorageColumnsWidths = localStorage.getItem('columnsWidths')
    const parsedColumnsWidths = localStorageColumnsWidths ? JSON.parse(localStorageColumnsWidths) : {}

    switch (action.type) {
        case INITIALIZE_MODULE: {
            return {
                ...defaultState,
                ...action.module.list,
                memorizeColumns: action.module.memorizeColumns,
                initialFields: action.module.list.fields,
                initialFieldsById: action.module.fields.byId,
                fields: action.module.list.fields,
                fieldsById: action.module.fields.byId,
                visibleColumns: action.module.list.fields.reduce(
                    (acc, fieldId) =>
                        Object.assign(acc, {
                            [fieldId]: !action.module.fields.byId[fieldId].initiallyNotVisible
                        }),
                    {}
                ),
                columnsWidths: {
                    ...action.module.list.fields.reduce(
                        (acc, fieldId) =>
                            Object.assign(acc, {
                                [fieldId]: action.module.fields.byId[fieldId].width
                            }),
                        {}
                    ),
                    ...(parsedColumnsWidths[action.module.list.accessId] || {})
                },
                sortBy: action.module.defaultSortBy || defaultState.sortBy,
                sortDirection:
                    action.module.defaultSortDirection ||
                    defaultState.sortDirection
            }
        }

        case SET_COLUMN_SELECTOR_OPENED:
            return {
                ...state,
                columnSelectorOpened: action.opened
            }

        case SET_ACTION_SELECTOR_OPENED:
            return {
                ...state,
                actionSelectorOpened: action.opened
            }

        case SET_FILTERS_OPENED:
            return {
                ...state,
                filtersOpened: action.opened
            }

        case SET_DATA_TABLE_FILTER_MODEL: {
            return {
                ...state,
                filterModel: action.filterModel || {}
            }
        }

        case SET_DATA_TABLE_SORT: {
            return {
                ...state,
                sortBy: action.sortBy,
                sortDirection: action.sortDirection
            }
        }

        case SORT_DATA_TABLE: {
            const dataGetter = getSortDataGetter({
                fields: state.fields,
                sortBy: action.sortBy
            })

            return {
                ...state,
                sortedIds: sort(
                    state.sortedIds,
                    id => dataGetter(state.byId[id]),
                    action.sortDirection
                ),
                filteredSortedIds: sort(
                    state.filteredSortedIds,
                    id => dataGetter(state.byId[id]),
                    action.sortDirection
                ),
                sortBy: action.sortBy,
                sortDirection: action.sortDirection
            }
        }

        case SET_LIST_ELEMENT_SELECTION: {
            return {
                ...state,
                byId : {
                    ...state.byId,
                    [action.id]: {
                        ...state.byId[action.id],
                        selected: action.isChecked
                    }

                }
            }
        }

        case FILTER_DATA_TABLE: {
            // Text filtering is now handled client-side via HighlightCell; rows stay visible,
            // so skip the expensive filteredSortedIds recomputation on every keystroke.
            return {
                ...state,
                filter: action.value
            }
        }

        case TOGGLE_COLUMN_VISIBILITY: {

            const localStorageVisibleColumns = localStorage.getItem('visibleColumns');

            const previousVisibleColumns = state.memorizeColumns && localStorageVisibleColumns
                ? JSON.parse(localStorageVisibleColumns)[state.accessId] || state.visibleColumns
                : state.visibleColumns

            const visibleColumns = {
                ...previousVisibleColumns,
                [action.columnId]: !previousVisibleColumns[action.columnId]
            }

            if(state.memorizeColumns) {
                localStorage.setItem('visibleColumns',
                    JSON.stringify({
                        ...JSON.parse( localStorageVisibleColumns),
                        [state.accessId]: visibleColumns
                    })
                );
            }

            const sortColumnStillVisible = visibleColumns[state.sortBy]
            const sortBy = sortColumnStillVisible ? state.sortBy : null
            const sortDirection = sortColumnStillVisible
                ? state.sortDirection
                : null

            const dataGetters = getFilterDataGetter({
                visibleColumns,
                fields: state.fields
            })

            return {
                ...state,
                visibleColumns,
                sortBy,
                sortDirection,
                filteredSortedIds: state.sortedIds.filter(id => {
                    const object = state.byId[id]

                    return dataGetters.some(dataGetter =>
                        valueMatchesTarget(dataGetter(object), state.filter)
                    )
                })
            }
        }

        case SET_FIELD_WIDTH:
            const localStorageColumnsWidths = localStorage.getItem('columnsWidths');
            const {id, width} = action
            const columnsWidths = {
                ...state.columnsWidths,
                [id]: width
            }
            if(state.memorizeColumns) {
                localStorage.setItem('columnsWidths',
                    JSON.stringify({
                        ...JSON.parse(localStorageColumnsWidths),
                        [state.accessId]: columnsWidths
                    })
                );
            }
            return {
                ...state,
                columnsWidths
            }

        case DT_REQUEST:
            return {
                ...state,
                isFetching: true,
                error: null,
                errorStatus: null
            }

        case DT_SUCCESS:
            const dataGetter =
                state.sortBy &&
                getSortDataGetter({
                    fields: state.fields,
                    sortBy: state.sortBy
                })

            const allIds = getDataIds(action.data)
            const byId = action.data.reduce(
                (acc, o) => (
                    { ...acc,
                        [o.id]: {...o, selected: false}
                    }),
                {}
            )
            const sortedIds = state.sortBy
                ? sort(allIds, id => dataGetter(byId[id]), state.sortDirection)
                : allIds

            /* handle dynamic columns */

            const fields = []
            const fieldsById = {}
            state.initialFields.forEach(fieldId => {
                if(!action.data.length || !state.initialFieldsById[fieldId]?.dynamic) {
                    fields.push(fieldId)
                    fieldsById[fieldId] = state.initialFieldsById[fieldId]
                }else{
                    const tempoFields = []
                    action.data.forEach(
                        object => {
                            Object.keys(object[fieldId.split('_')[1]]).forEach(
                                key => {
                                    const newFieldId = `${fieldId}.${key}`
                                    if(!tempoFields.includes(newFieldId)) {
                                        tempoFields.push(newFieldId)
                                    }
                                }
                            )
                        }
                    )
                    if(state.initialFieldsById[fieldId].disableColumnsSort) {
                        tempoFields.forEach(innerFieldId => {
                            const path = innerFieldId.split('_')[1]
                            const label = innerFieldId.split('.')[1]
                            fields.push(innerFieldId)
                            fieldsById[innerFieldId] = {
                                ...state.initialFieldsById[fieldId],
                                dataKey: path,
                                id: innerFieldId,
                                label: label,
                                path: path,
                                tKey: label,
                                dynamic: false
                            }
                        })
                    } else {
                        tempoFields.sort().reverse().forEach(innerFieldId => {
                            const path = innerFieldId.split('_')[1]
                            const label = innerFieldId.split('.')[1]
                            fields.push(innerFieldId)
                            fieldsById[innerFieldId] = {
                                ...state.initialFieldsById[fieldId],
                                dataKey: path,
                                id: innerFieldId,
                                label: label,
                                path: path,
                                tKey: label,
                                dynamic: false
                            }
                        })
                    }

                }
            })

            return {
                ...state,
                sortedIds: sortedIds,
                filteredSortedIds: sortedIds,
                isFetching: false,
                allIds: allIds,
                byId: byId,
                fields,
                fieldsById,
                visibleColumns: fields.reduce(
                    (acc, fieldId) => {
                        return Object.assign(acc, {
                            [fieldId]: state.visibleColumns[fieldId]
                                ? state.visibleColumns[fieldId]
                                : !fieldsById[fieldId].initiallyNotVisible
                        })
                    },
                    {}
                ),
                columnsWidths: {
                    ...fields.reduce(
                        (acc, fieldId) =>
                            Object.assign(acc, {
                                [fieldId]: fieldsById[fieldId].width
                            }),
                        {}
                    ),
                    ...(parsedColumnsWidths[state.accessId] || {})
                },

            }

        case DT_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.error,
                errorStatus: action.status
            }

        case CREATE_OBJECT_SUCCESS: {
            if (!action.data || !action.data.id) return state

            const filterDataGetters = getFilterDataGetter(state)

            const allIds = [...state.allIds, action.data.id]
            const byId = {
                ...state.byId,
                [action.data.id]: action.data
            }

            let sortedIds

            if (state.sortBy) {
                const sortDataGetter = getSortDataGetter(state)

                sortedIds = sort(
                    allIds,
                    id => sortDataGetter(byId[id]),
                    state.sortDirection
                )
            } else {
                sortedIds = allIds
            }

            const filteredSortedIds = sortedIds.filter(id => {
                const object = byId[id]

                return filterDataGetters.some(dataGetter =>
                    valueMatchesTarget(dataGetter(object), state.filter)
                )
            })

            return {
                ...state,
                allIds,
                byId,
                sortedIds,
                filteredSortedIds
            }
        }

        case SAVE_OBJECT_SUCCESS: {
            let enhancer

            if (action.data) {
                let data = action.data
                if(! _.isArray(data)) data = [data]

                const byId = data.reduce((acc, obj) => {
                    return {
                        ...acc,
                        [obj.id]: obj
                    }
                }, state.byId)

                const allIds = state.allIds

                data.forEach(obj => {
                    if(!state.allIds.includes(obj.id)) {
                     allIds.push(obj.id)
                    }
                })

                let sortedIds = allIds
                if (state.sortBy) {
                    const sortDataGetter = getSortDataGetter(state)

                    sortedIds = sort(
                        sortedIds,
                        id => sortDataGetter(byId[id]),
                        state.sortDirection
                    )
                }

                const filterDataGetters = getFilterDataGetter(state)

                const filteredSortedIds = sortedIds.filter(id => {
                    const object = byId[id]

                    return filterDataGetters.some(dataGetter =>
                        valueMatchesTarget(dataGetter(object), state.filter)
                    )
                })

                enhancer = {
                    byId,
                    allIds,
                    sortedIds,
                    filteredSortedIds
                }
            } else {
                enhancer = {
                    allIds: state.allIds.filter(id => id !== action.id),
                    byId: Object.keys(state.byId).reduce(
                        (acc, id) =>
                            id === action.id
                                ? acc
                                : { ...acc, [id]: state.byId[id] },
                        {}
                    ),
                    sortedIds: state.sortedIds.filter(id => id !== action.id),
                    filteredSortedIds: state.filteredSortedIds.filter(
                        id => id !== action.id
                    )
                }
            }

            return {
                ...state,
                ...enhancer
            }
        }

        case ACTION_OBJECT_REQUEST:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.id]: {
                        ...state.byId[action.id],
                        isInAction: true
                    }
                }
            }
        case ACTION_OBJECT_SUCCESS:
        case ACTION_OBJECT_FAILURE:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.id]: {
                        ...state.byId[action.id],
                        isInAction: false
                    }
                }
            }


        case DELETE_OBJECT_REQUEST:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.id]: {
                        ...state.byId[action.id],
                        isDeleting: true
                    }
                }
            }

        case DELETE_OBJECT_SUCCESS: {
            const allIds = state.allIds.filter(id => id !== action.id)

            return {
                ...state,
                allIds,
                byId: allIds.reduce(
                    (acc, id) => ({ ...acc, [id]: state.byId[id] }),
                    {}
                ),
                sortedIds: state.sortedIds.filter(id => id !== action.id),
                filteredSortedIds: state.filteredSortedIds.filter(
                    id => id !== action.id
                )
            }
        }

        case DELETE_OBJECT_FAILURE:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.id]: {
                        ...state.byId[action.id],
                        isDeleting: false
                    }
                }
            }

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                errorStatus: null
            }

        default:
            return state
    }
}

export default list
